import utilsStyles from '@/styles/modules/utils.module.scss';
import clsx from 'clsx';
import Image, { type StaticImageData } from 'next/image';
import styles from './OptionTitle.module.scss';

type OptionTitleSize = 'default' | 'small';

const SIZE_CLASS: Record<OptionTitleSize, string> = {
  default: styles.sizeDefault,
  small: styles.sizeSmall,
};

function OptionTitle({
  title,
  image,
  linkText,
  onLinkClick,
  size = 'default',
}: {
  title: string;
  // 指定時は title テキストの代わりに見出しを画像で表示する（title は画像の alt に流用）
  image?: StaticImageData;
  linkText?: string;
  onLinkClick?: () => void;
  size?: OptionTitleSize;
}) {
  return (
    <div className={clsx(styles.productOptionTitle, SIZE_CLASS[size])}>
      {image ? (
        // Lambda 上の next/image 最適化(/_next/image)は内部静的アセットのパスを解決できず本番で画像が壊れるため、
        // 静的 import は unoptimized で最適化を通さず直接配信する（HowToMakeSlider 等と同方針）。
        // 表示サイズは CSS(height + width:auto)で制御
        <Image src={image} alt={title} className={styles.productOptionTitleImage} unoptimized />
      ) : (
        <p className={styles.productOptionTitleText}>{title}</p>
      )}
      {linkText && (
        <p className={clsx(utilsStyles.textLink, styles.productOptionLink)} onClick={onLinkClick}>
          {linkText}
        </p>
      )}
      <hr className={styles.productOptionTitleHr} />
    </div>
  );
}

export default OptionTitle;
